import styled from "styled-components";
import PieChart from "../../components/charts/PieChart";
import Users from "../users/Users";
import DemoData from "../../data/DemoData";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import ProjectSubmissionItem from "./ProjectSubmissionItem";
import ProjectSubmissionsList from "./ProjectSubmissionsList";
import { connect, useDispatch } from "react-redux";
import { useActionsContext } from "../../context/ActionsContext";

function ProjectSubmissions({value,}) {
  const { user } = useContext(AuthContext);
const dispatch =useDispatch()

  const [edit, setedit] = useState(false);

  const[project,setProject]=useState(null);

  const tasktype = useRef();

  const changeTaskStatus = (event) => {
    settaskstatus(event);
    getTasks(event);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [tasks, settasks] = useState(null);
  const [category, setcategory] = useState("all");

  const [taskstatus, settaskstatus] = useState("all");

  const [taskid, settaskid] = useState(null);
  const [remove, setremove] = useState(false);
  const [removeid, setremoveid] = useState(null);
  const [submit, setsubmit] = useState(false);

  const showSubmit = (e) => {
    const id = e.target.id;
    settaskid(id.replace("submit", ""));
    setsubmit(true);
  };

  const closeSubmit = () => {
    setsubmit(false);
  };
  const editTask = (assignmentid) => {
    settaskid(assignmentid);

    setedit(true);
  };

  const closeEdit = () => {
    setedit(false);
  };
  const [add, setadd] = useState(false);

  const closeAddition = () => {
    setadd(false);
    getTasks(taskstatus);
  };

  const showRemove = (e) => {
    const id = e.target.id;

    settaskid(id.replace("delete", ""));
    setremove(true);
  };
  const closeRemove = () => {
    setremove(false);
  };



  const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
  
  const getTasks = async (status) => {
    dispatch({ type: 'LOADING' });
  
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append('limit', rowsPerPage);
    formData.append("status", status);
  
    try {
      const res = await axios.post(
        ENDPOINT + "admin-get-project-submissions.php",
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );
  
      if (res) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' });
          settasks(res.data.data);
          setResponse(res.data.data);
          setProject(res.data);
        } else {
          dispatch({   
            type: 'ERROR', 
            payload: res.data.message || 'Failed to fetch tasks' 
          });
        }
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while fetching tasks' 
      });
    }
  };
  useEffect(() => {
    getTasks(taskstatus);
  }, [rowsPerPage]);

  //delete task code

  const deleteTask = async () => {
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("id", taskid);

    const res = await axios.post(ENDPOINT + "admin-delete-task.php", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    if (res.data[0].status === "success") {
      getTasks();
      closeRemove();
    } else {
    }
   
  };

  const Reload = () => {
    getTasks();
  };

  const [response, setResponse] = useState(tasks);
  const [searchTerm, setSearchTerm] = useState("");
  const {searchquery} = useActionsContext()
  useEffect(()=>{
    handleSearch({term:searchquery})
  },[searchquery])
  const handleSearch = ({term}) => {

    if(term && tasks)
    {
      const filteredData = tasks.filter((item) => {
        return (
          item.first_name.toLowerCase().includes(term) ||
          item.last_name.toLowerCase().includes(term) ||
          item.status.toLowerCase().includes(term) ||
          item.submission_time.toLowerCase().includes(term)
        );
      });
  
      setResponse(filteredData);
      setSearchTerm(term);
    }
   
  };

  useEffect(() => {
    if(value.functionName === 'project-submissions'){
      getTasks()
    }
  }, [value]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="h-100">
              {tasks ? (
                <>
                  {/*end row*/}
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                <i className="ri-arrow-down-circle-fill align-middle" />
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                Submitted{" "}
                              </p>
                              <h4 className=" mb-0">
                                {project?project.project_submit.project_submit:null}
                                <span
                                  className="counter-value"
                                  data-target="14799.44"
                                >
                                {/* {tasks?tasks.project_submit.project_submit:null} */}
                                </span>
                              </h4>
                            </div>
                            <div className="flex-shrink-0 align-self-end">
                              <span className="badge bg-danger-subtle text-danger">
                                <i className="ri-arrow-down-s-fill align-middle me-1" />
                                4.80 %<span> </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* end card body */}
                      </div>
                      {/* end card */}
                    </div>
                    {/* end col */}

                    {/* end col */}
                    <div className="col-lg-3 col-md-3 col-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                <i className="ri-arrow-down-circle-fill align-middle" />
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                Evaluated{" "}
                              </p>
                              <h4 className=" mb-0">
                                $
                                <span
                                  className="counter-value"
                                  data-target="14799.44"
                                >
                                  0
                                </span>
                              </h4>
                            </div>
                            <div className="flex-shrink-0 align-self-end">
                              <span className="badge bg-danger-subtle text-danger">
                                <i className="ri-arrow-down-s-fill align-middle me-1" />
                                4.80 %<span> </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* end card body */}
                      </div>
                      {/* end card */}
                    </div>
                    {/* end col */}

                    {/* end col */}
                    <div className="col-lg-3 col-md-3 col-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                <i className="ri-arrow-down-circle-fill align-middle" />
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                Completed{" "}
                              </p>
                              <h4 className=" mb-0">
                                $
                                <span
                                  className="counter-value"
                                  data-target="14799.44"
                                >
                                  0
                                </span>
                              </h4>
                            </div>
                            <div className="flex-shrink-0 align-self-end">
                              <span className="badge bg-danger-subtle text-danger">
                                <i className="ri-arrow-down-s-fill align-middle me-1" />
                                4.80 %<span> </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* end card body */}
                      </div>
                      {/* end card */}
                    </div>
                    {/* end col */}

                    {/* end col */}
                    <div className="col-lg-3 col-md-3 col-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                <i className="ri-arrow-down-circle-fill align-middle" />
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                Rejected{" "}
                              </p>
                              <h4 className=" mb-0">
                                $
                                <span
                                  className="counter-value"
                                  data-target="14799.44"
                                >
                                  0
                                </span>
                              </h4>
                            </div>
                            <div className="flex-shrink-0 align-self-end">
                              <span className="badge bg-danger-subtle text-danger">
                                <i className="ri-arrow-down-s-fill align-middle me-1" />
                                4.80 %<span> </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* end card body */}
                      </div>
                      {/* end card */}
                    </div>
                    {/* end col */}
                  </div>{" "}
                  {/* end row*/}
                </>
              ) : (
                <></>
              )}

              <div className="tab-pane " id="documents" role="tabpanel">
                <div className="card">
                  <div className="card-body">
                    <div className="card-body border border-dashed border-end-0 border-start-0">
                      <form className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                        <div className="row g-3">
                          {/* <div className="col-xxl-3 col-sm-4">
                            <div className="search-box">
                              <input
                               onChange={(e)=>{handleSearch({term:e.target.value.toLowerCase()})}}
                                type="text"    
                                className="form-control search"
                                placeholder="Search for order ID, customer, order status or something..."
                              />
                              <i className="ri-search-line search-icon" />
                            </div>
                          </div> */}
                          {/*end col*/}
                          {/* <div className="col-xxl-2 col-sm-6">
                            <div>
                              <input
                                type="date"
                                 onChange={(e)=>{handleSearch({term:e.target.value.toLowerCase()})}}
                                className="form-control"
                                data-provider="flatpickr"
                                data-date-format="d M, Y"
                                data-range-date="true"
                                id="demo-datepicker"
                                placeholder="Select date"
                              />
                            </div>
                          </div> */}
                          {/*end col*/}
                          {/* <div className="col-xxl-2 col-sm-4">
                            <div>
                              <select
                                className="form-control"
                                data-choices=""
                                data-choices-search-false=""
                                name="choices-single-default"
                                id="idStatus"
                                 onChange={(e)=>{handleSearch({term:e.target.value.toLowerCase()})}}
                              >
                                <option value="">Status</option>
                             
                                <option value="pending">Pending</option>
                                <option value="submitted">Submitted</option>
                               
                              </select>
                            </div>
                          </div> */}
                          {/*end col*/}
                          {/* <div className="col-xxl-2 col-sm-4">
                            <div>
                              <select
                                className="form-control"
                                data-choices=""
                                data-choices-search-false=""
                                name="choices-single-default"
                                id="idPayment"
                              >
                                <option value="">Select Payment</option>
                                <option value="all" selected="">
                                  All
                                </option>
                                <option value="Mastercard">Mastercard</option>
                                <option value="Paypal">Paypal</option>
                                <option value="Visa">Visa</option>
                                <option value="COD">COD</option>
                              </select>
                            </div>
                          </div> */}
                          {/*end col*/}
                          <div className="col-xxl-3 col-sm-4">
                            <div className="d-flex">
                              {/* <button
                                type="button"
                                className="btn me-2 btn-primary "
                                onclick="SearchData();"
                              >
                                {" "}
                                <i className="ri-equalizer-fill me-1 align-bottom" />
                                Filters
                              </button> */}

                              <button className="btn btn-danger w-fit h-fit">
                                Add new Task
                              </button>
                            </div>
                          </div>
                          {/*end col*/}
                        </div>
                        {/*end row*/}
                      </form>
                    </div>

                    <ProjectSubmissionsList tasks={response} Reload={Reload} />
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end .h-100*/}
          </div>{" "}
          {/* end col */}
          {/* end col */}
        </div>
      </div>
    </>
  );
}

const reduxStore = (prop)=>({
  value:prop.modalHandler
})

export default connect(reduxStore) (ProjectSubmissions);

const StyledSuperAdminDashboard = styled.div`
  h1 {
    color: red;
  }
`;